/* Marken-Strip: horizontales Scrollen mit Pfeilen (Desktop) + Maus-Drag.
   Touch nutzt natives Scrollen (Swipe). Pfeile erscheinen nur bei Overflow.
   Markup/CSS: sections/brand-strip.liquid. Geladen auf Startseite, Produktseite und
   Warenkorbseite (layout/theme.liquid) — die Scroll-Mechanik ist generisch (data-brand-*-
   Attribute) und wird via window.initBrandStrip auch von "Zuletzt angesehen" genutzt
   (product-page.js initialisiert dort manuell NACH dem Karten-Inject; die Sektion
   traegt bewusst kein data-brand-strip, sonst wuerde der Autoload leer initialisieren),
   seit 2026-10-20 auch vom Cross-Selling der Warenkorbseite (cart-page.js, beim Laden
   und nach jedem Section-Swap), seit 2026-10-21 vom Bewertungs-Karussell der Warenkorb-
   Zusammenfassung (ebenso). Dazu seit 2026-10-21 «Mehr lesen» der Bewertungs-Kacheln
   (window.initReviewCards, unten) — beide Kachel-Streifen laufen auf dieser Datei.
   Pfeile und Punkte scrollen unter prefers-reduced-motion ohne Animation. */
(function () {
  // Unter reduced-motion springen Pfeile und Punkte statt zu gleiten (behavior 'smooth'
  // ueberstimmt sonst jede CSS-Regel). Bei jedem Klick gelesen: die Einstellung kann sich
  // waehrend der Sitzung aendern.
  const bewegungAus = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function scrollArt() { return bewegungAus && bewegungAus.matches ? 'auto' : 'smooth'; }

  function initStrip(strip) {
    var viewport = strip.querySelector('[data-brand-viewport]');
    if (!viewport) return;
    var prev = strip.querySelector('[data-brand-prev]');
    var next = strip.querySelector('[data-brand-next]');

    var wrap = viewport.parentElement; // .brand-strip__viewport-wrap traegt die Scroll-Fades
    var raf = null;
    function abschalten(btn, aus, gegen) {
      if (!btn) return;
      if (aus && document.activeElement === btn && gegen && !gegen.disabled && !gegen.hidden) gegen.focus({ preventScroll: true });
      btn.disabled = aus;
    }
    function updateArrows() {
      raf = null;
      var overflow = viewport.scrollWidth > viewport.clientWidth + 1;
      if (prev) prev.hidden = !overflow;
      if (next) next.hidden = !overflow;
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      var atStart = viewport.scrollLeft <= 1;
      var atEnd = viewport.scrollLeft >= maxScroll - 1;
      if (overflow) {
        // Hausmuster der GradedGuard-Galerie (gradedguard.js abschalten): erst freigeben, dann
        // sperren; wird ein Pfeil gesperrt, waehrend er den Fokus hat, geht der Fokus vorher auf
        // den Gegenpfeil — sonst fiel er auf <body> und der naechste Tab sprang hinter das
        // Karussell (Audit Warenkorb A-11).
        if (prev && !atStart) prev.disabled = false;
        if (next && !atEnd) next.disabled = false;
        abschalten(next, atEnd, prev);
        abschalten(prev, atStart, next);
      }
      // Scroll-Fades (Mobile): nur einblenden, wenn in der Richtung noch Inhalt verborgen ist
      if (wrap) {
        wrap.classList.toggle('is-overflow-start', overflow && !atStart);
        wrap.classList.toggle('is-overflow-end', overflow && !atEnd);
      }
    }
    function scheduleUpdate() {
      if (raf) return;
      raf = window.requestAnimationFrame(updateArrows);
    }

    // Pfeil-Schrittweite: Default 80% Viewport (brand-strip: mehrere Logos pro Klick);
    // data-scroll-step="item" am Strip-Root -> genau EIN Element pro Klick
    // ("Zuletzt angesehen": eine Produktkarte, nicht ans andere Ende springen).
    var stepMode = strip.getAttribute('data-scroll-step');
    function step(dir) {
      var amount = viewport.clientWidth * 0.8;
      if (stepMode === 'item') {
        var track = viewport.firstElementChild;
        var item = track && track.firstElementChild;
        if (item) {
          var st = getComputedStyle(track);
          var gap = parseFloat(st.columnGap || st.gap || '0') || 0;
          amount = item.getBoundingClientRect().width + gap;
        }
      }
      viewport.scrollBy({ left: dir * amount, behavior: scrollArt() });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // Drag-to-scroll: geteilte Mechanik window.hdkDragScroll (theme.js) — nur Maus,
    // Capture erst ab echtem Drag, dragstart-Sperre, Klick nach Drag unterdrueckt.
    // klasseSofort: der Strip zeigt den grabbing-Cursor schon beim Druecken (wie bisher).
    window.hdkDragScroll(viewport, { klasseSofort: true });

    viewport.addEventListener('scroll', scheduleUpdate, { passive: true });
    // Resize haengt am window und ueberlebte so einen Streifen, den ein Section-Swap
    // ersetzt (Warenkorbseite, seit 2026-10-20) — samt seinem alten DOM. Ist der
    // Viewport nicht mehr im Dokument, meldet sich der Listener selbst ab.
    function onResize() {
      if (!viewport.isConnected) { window.removeEventListener('resize', onResize); return; }
      scheduleUpdate();
    }
    window.addEventListener('resize', onResize);

    // Logos koennen die Breite erst nach dem Laden festlegen -> neu messen
    var imgs = viewport.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) imgs[i].addEventListener('load', scheduleUpdate);
    }

    updateArrows();

    // Punkte beim Autoload gleich mit (Kundenstimmen-Karussell traegt [data-strip-dots]);
    // Produkt-Streifen rufen initStripDots selbst nach dem Karten-Inject.
    var dotsWrap = strip.querySelector('[data-strip-dots]');
    if (dotsWrap) initStripDots(strip, dotsWrap);
  }

  // Positions-Dots (alle Breakpoints): ein Dot je SCROLL-POSITION, nicht je Karte —
  // Anzahl = ceil(maxScroll / Kartenschritt) + 1; ein Dot pro Karte waere irrefuehrend,
  // die hinteren Karten erreichen die linke Kante nie. Sichtbar erst bei Overflow; ohne
  // Overflow (alles sichtbar, Track zentriert) bleibt der Container hidden. Bei Resize
  // wird neu gezaehlt/gebaut. root = Element mit [data-brand-viewport] darin (Track =
  // dessen erstes Kind), wrap = Dot-Container (globale .rec-dot-Styles, theme.css).
  // Bis 15.10.2026 in product-page.js (nur Produktseite); seit dem Kundenstimmen-
  // Karussell (Startseite) hier als window.initStripDots — product-page.js ruft es
  // fuer «Zuletzt angesehen», «Ähnliche Artikel» und «Oft kombiniert mit» nach dem
  // Karten-Inject.
  function initStripDots(root, wrap) {
    var viewport = root ? root.querySelector('[data-brand-viewport]') : null;
    var track = viewport ? viewport.firstElementChild : null;
    if (!viewport || !track || !wrap) return;
    var cards = track.children;
    if (cards.length < 2) return;

    function stepWidth() {
      var s = getComputedStyle(track);
      var gap = parseFloat(s.columnGap || s.gap || '0') || 0;
      return (cards[0] ? cards[0].getBoundingClientRect().width : viewport.clientWidth) + gap;
    }
    function maxScroll() {
      return viewport.scrollWidth - viewport.clientWidth;
    }
    function positionCount() {
      var max = maxScroll();
      if (max <= 1) return 1;
      // -0.02 Toleranz gegen Subpixel-Rundung (sonst entsteht ein Geister-Dot)
      return Math.ceil(max / stepWidth() - 0.02) + 1;
    }

    var dots = [];
    function rebuild(count) {
      wrap.textContent = '';
      dots = [];
      for (var i = 0; i < count; i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rec-dot';
          b.setAttribute('aria-label', window.themeStrings.sliderPosition.replace('__N__', idx + 1));
          b.addEventListener('click', function () {
            viewport.scrollTo({ left: Math.min(idx * stepWidth(), maxScroll()), behavior: scrollArt() });
          });
          wrap.appendChild(b);
          dots.push(b);
        })(i);
      }
    }

    var raf = null;
    function sync() {
      raf = null;
      var max = maxScroll();
      var overflow = max > 1;
      wrap.hidden = !overflow;
      if (!overflow) return;
      var count = positionCount();
      if (count !== dots.length) rebuild(count);
      var idx = viewport.scrollLeft >= max - 1
        ? dots.length - 1
        : Math.round(viewport.scrollLeft / stepWidth());
      idx = Math.max(0, Math.min(dots.length - 1, idx));
      // Zustand auch fuer Screenreader (Audit Warenkorb A-11): aria-current wie die Punkte der
      // GradedGuard-Galerie (Hausmuster, docs/decisions.md 2026-10-04 (11)).
      for (var n = 0; n < dots.length; n++) {
        dots[n].classList.toggle('is-active', n === idx);
        if (n === idx) dots[n].setAttribute('aria-current', 'true');
        else dots[n].removeAttribute('aria-current');
      }
    }
    function schedule() { if (!raf) raf = window.requestAnimationFrame(sync); }
    viewport.addEventListener('scroll', schedule, { passive: true });
    // Selbst-Abmeldung wie in initStrip (Streifen per Section-Swap ersetzt)
    function onResize() {
      if (!viewport.isConnected) { window.removeEventListener('resize', onResize); return; }
      schedule();
    }
    window.addEventListener('resize', onResize);
    sync();
  }

  // «Mehr lesen» der Bewertungs-Kacheln (snippets/review-card.liquid): Knopf nur bei echtem
  // Ueberlauf des auf 6 Zeilen gekappten Zitats (gemessen, nicht geraten), Klick klappt die
  // Kachel auf und zu. Bis 21.10.2026 im javascript-Block von sections/home-reviews.liquid;
  // der landet in Shopifys compiled_assets/scripts.js, und das laedt /cart nicht (die Seite
  // rendert keine Datei mit javascript-/stylesheet-Block, gemessen 21.10.2026). Diese Datei
  // laedt auf allen drei Kachel-Seiten (Startseite, Produktseite, /cart).
  //  - Messen: initReviewCards(root) fuer alle offenen Kacheln unter root (Default: das
  //    Dokument) — beim Laden, bei Resize und nach dem Laden der Schriften fuer das ganze
  //    Dokument, dazu von cart-page.js fuer frisch eingesetzte Kacheln nach jedem Swap.
  //  - Klick: EIN delegierter Listener am Dokument, ueberlebt jeden Section-Swap.
  function initReviewCards(root) {
    (root || document).querySelectorAll('.home-reviews__card:not(.is-open)').forEach(function (card) {
      const text = card.querySelector('[data-clamp]');
      const knopf = card.querySelector('[data-more]');
      if (!text || !knopf) return;
      knopf.hidden = !(text.scrollHeight > text.clientHeight + 2);
    });
  }
  document.addEventListener('click', function (e) {
    const knopf = e.target.closest && e.target.closest('.home-reviews__card [data-more]');
    if (!knopf) return;
    const card = knopf.closest('.home-reviews__card');
    const offen = card.classList.toggle('is-open');
    knopf.setAttribute('aria-expanded', String(offen));
    knopf.textContent = offen ? knopf.getAttribute('data-less-text') : knopf.getAttribute('data-more-text');
    // Beim EINklappen bleibt die Oberkante der Karte an Ort, nur der untere Teil zieht
    // hoch (Cyre 16.10.2026; das Festhalten des Knopfs wie bei .product-details__more
    // verschob den sichtbaren Inhalt nach unten). Liegt die Oberkante bereits hinter
    // dem Sticky-Header, wird die Karte an die Oberkante geholt — sonst stuende nach
    // dem Einklappen nur der Inhalt unterhalb der Karte im Bild.
    // behavior:'instant' ueberstimmt das globale scroll-behavior:smooth.
    if (!offen) {
      const header = document.querySelector('.site-header.is-stuck');
      const kante = (header ? header.getBoundingClientRect().bottom : 0) + 12;
      const kartenTop = card.getBoundingClientRect().top;
      if (kartenTop < kante) window.scrollBy({ top: kartenTop - kante, behavior: 'instant' });
    }
  });
  window.addEventListener('resize', function () { initReviewCards(document); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { initReviewCards(document); });

  // Fuer spaet befuellte Strips (z.B. "Zuletzt angesehen"): einmal pro Element aufrufen
  window.initBrandStrip = initStrip;
  window.initStripDots = initStripDots;
  window.initReviewCards = initReviewCards;

  function init() {
    var strips = document.querySelectorAll('[data-brand-strip]');
    for (var i = 0; i < strips.length; i++) initStrip(strips[i]);
    initReviewCards(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
